import {
  getRedirectResult,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  UserCredential,
} from 'firebase/auth';
import { getDoc, doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { Authority, UserStaus } from 'src/types/types';

export const signOut = async () => {
  await auth.signOut();
};

export const googleSignUpWithPopup = async (): Promise<void> => {
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  console.log(result);
  await makeUser(result);
  return;
};

export const googleSignUpWithRedirect = async () => {
  const provider = new GoogleAuthProvider();
  await signInWithRedirect(auth, provider);
};

export const handleGoogleRedirectResult = async () => {
  if (auth.currentUser?.uid) {
    return;
  }
  try {
    const result = await getRedirectResult(auth);
    await makeUser(result);
  } catch (err: any) {
    throw new Error(err);
  }
  return;
};

const makeUser = async (result: UserCredential | null) => {
  if (!result) {
    return;
  }
  // The signed-in user info.
  const user = result.user;

  let status = UserStaus.PENDING;

  if (user.email?.split('@').at(-1) === 'khu.ac.kr') {
    status = UserStaus.APPROVED;
  }

  if ((await getDoc(doc(db, 'user', user.uid))).exists()) {
    return;
  }

  await setDoc(
    doc(db, 'user', user.uid),
    {
      userEmail: user.email,
      userName: user.displayName,
      createdAt: new Date(),
      profileImage: null,
      stamps: [],
      authority: Authority.USER,
      status,
    },
    { merge: true }
  ).catch((err) => console.log(err));

  return;
};

export const getUserDataById = async (id: string) => {
  const docRef = doc(db, 'user', id);
  const docSnap = await getDoc(docRef);
  if (!docSnap.exists()) {
    throw new Error('존재하지 않는 유저입니다.');
  }
  return { name: docSnap.data()?.userName, email: docSnap.data()?.userEmail };
};
